// extracted by mini-css-extract-plugin
export default {"ComponentParameterGroup":"ComponentParameterGroup_ComponentParameterGroup__+-GHq","ComponentParameterGroup__Label":"ComponentParameterGroup_ComponentParameterGroup__Label__JNM0q"};